import { render, staticRenderFns } from "./SpaceController.vue?vue&type=template&id=10a20846"
import script from "./SpaceController.vue?vue&type=script&lang=js"
export * from "./SpaceController.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports